module.exports = __webpack_public_path__ + "static/media/icon_help.1a903d8d.svg";